import { Layout, Menu, Row } from "antd";
import React, { useRef } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import { firebaseAuth } from "@/infrastructure/firebase";

import styles from "./styles.less";
import { SlidersOutlined, LogoutOutlined, UserAddOutlined, UserSwitchOutlined } from "@ant-design/icons/lib";
import { useRootSelector } from "@/infrastructure/hooks";
import { RootState } from "@/infrastructure/rootState";
import { useDispatch } from "react-redux";
import { AppAction } from "@/features/applications";

export default () => {
  let prevScrollPos = useRef<number>(window.pageYOffset);
  const dispatch = useDispatch();
  const history = useHistory();
  const { pathname } = useLocation();
  const { isSuperuser, loading } = useRootSelector(({ app: { userInfo, loading } }: RootState) => ({
    isSuperuser: userInfo.isSuperuser,
    loading: loading.userInfo === "REQUEST"
  }));

  return (
    <Layout.Header className={styles.header}>
      <div className={styles.container}>
        <div className={styles.title}>
          <Row justify={"space-between"}>
            <Link className={styles.text} to={"/"}>
              Home
            </Link>
            <Menu mode={"horizontal"} className={styles.menu} forceSubMenuRender={true}>
              {["/login", "/register"].includes(pathname) ? (
                <>
                  <Menu.Item className={styles.menuItem} key={"register"}>
                    <Link to={"/register"}>
                      <UserAddOutlined style={{ fontSize: 20 }} />
                      <span className={styles.iconOnly}>Register</span>
                    </Link>
                  </Menu.Item>
                  <Menu.Item className={styles.menuItem} key={"login"}>
                    <Link to={"/login"}>
                      <UserSwitchOutlined style={{ fontSize: 20 }} />
                      <span className={styles.iconOnly}>Login</span>
                    </Link>
                  </Menu.Item>
                </>
              ) : (
                <>
                  <Menu.Item className={styles.menuItem} key={"backtesting"}>
                    <Link to={"/backtest"}>
                      <SlidersOutlined style={{ fontSize: 20 }} />
                      <span className={styles.iconOnly}>Backtest</span>
                    </Link>
                  </Menu.Item>
                  <Menu.Item className={styles.menuItem} key={"login-status"}>
                    {!loading && !isSuperuser ? (
                      <Link to={"/login"}>
                        <UserSwitchOutlined style={{ fontSize: 20 }} />
                        <span className={styles.iconOnly}>Login</span>
                      </Link>
                    ) : (
                      <Link to={pathname} onClick={() => logout()}>
                        <LogoutOutlined style={{ fontSize: 20 }} />
                        <span className={styles.iconOnly}>Logout</span>
                      </Link>
                    )}
                  </Menu.Item>
                </>
              )}
            </Menu>
          </Row>
        </div>
      </div>
    </Layout.Header>
  );

  function logout() {
    history.push("/login");
    firebaseAuth.signOut().then(() => {
      history.push("/login");
    });
    dispatch(
      AppAction.updateUserInfo({
        username: "",
        userId: "",
        email: "",
        watchlist: {},
        isSuperuser: false
      })
    );
  }
};
